import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconApiConnection: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconApiConnection"><Path d="M3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C15.6384 20.5 18.7428 18.214 19.9554 15M3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C15.6384 3.5 18.7428 5.78597 19.9554 9M3.5 12H1.5M16.5 12C16.5 14.4853 14.4853 16.5 12 16.5C9.51472 16.5 7.5 14.4853 7.5 12C7.5 9.51472 9.51472 7.5 12 7.5C14.4853 7.5 16.5 9.51472 16.5 12ZM16.5 12H22.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconApiConnection;
